module.exports = __webpack_public_path__ + "static/media/lidl.01048a54.jpg";